import { Injectable } from "@angular/core";
import { TokenService } from "@delon/auth";
import { UserTypes } from "../enums/keys.enum";

@Injectable({
  providedIn: "root",
})
export class UserGuard  {
  
  constructor(
    private tokenService: TokenService,
  ) {}

  canActivateChild() {
    const accType = this.tokenService.get();
    if (accType.type == UserTypes.USER) return true;

    //this.notification.info('', 'You do not have permission to view this page !', 'invalid')
    // this.router.navigate(['/verify/certificate']);s
    return false;
  }
}
